export const GET_prod_DATA_REQUEST = "GET_prod_DATA_REQUEST";
export const GET_prod_DATA_SUCCESS = "GET_prod_DATA_SUCCESS";
export const GET_prod_DATA_FAILURE = "GET_prod_DATA_FAILURE";
